import { ErrorHandler, Injectable } from '@angular/core';

// Benigní varování prohlížeče, která nechceme reportovat.
// "ResizeObserver loop ..." dle specifikace znamená, že prohlížeč zbývající
// notifikace doručí v následujícím snímku – nejde o chybu aplikace. Vzniká
// typicky uvnitř knihoven (Angular Material / CDK, gov.cz design systém),
// které samy používají ResizeObserver, a nelze je odstranit z naší komponenty.
const IGNOROVANE_ZPRAVY = [
  'ResizeObserver loop completed with undelivered notifications',
  'ResizeObserver loop limit exceeded',
];

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  override handleError(error: unknown): void {
    if (this.jeIgnorovanaChyba(error)) {
      return;
    }
    super.handleError(error);
  }

  // Zpráva může být zanořená v .message, .cause (Error) nebo .error (ErrorEvent),
  // proto rekurzivně posbíráme text ze všech těchto míst.
  private jeIgnorovanaChyba(error: unknown): boolean {
    const zprava = this.ziskejZpravu(error);
    return IGNOROVANE_ZPRAVY.some(m => zprava.includes(m));
  }

  private ziskejZpravu(error: unknown, hloubka = 0): string {
    if (error == null || hloubka > 5) return '';
    if (typeof error === 'string') return error;

    const e = error as { message?: unknown; cause?: unknown; error?: unknown };
    const casti: string[] = [];
    if (typeof e.message === 'string') casti.push(e.message);
    if (e.cause != null) casti.push(this.ziskejZpravu(e.cause, hloubka + 1));
    if (e.error != null) casti.push(this.ziskejZpravu(e.error, hloubka + 1));
    return casti.join(' ');
  }
}
